var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSenha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_senha_svg__b{fill:none}.icon_senha_svg__g{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 4.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon_senha_svg__b",
    d: "M3.602 9.343V6.26h.011A6.508 6.508 0 0110.002 0a6.508 6.508 0 016.387 6.26h.013v3.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.402 8.343V6.48l-.009-.165A5.509 5.509 0 0010.002 1a5.509 5.509 0 00-5.39 5.313l-.01.167v1.863h10.8m1 1h-12.8V6.26h.011A6.508 6.508 0 0110.002 0a6.507 6.507 0 016.386 6.26h.014v3.083z",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.357)",
    stroke: "#707070",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "icon_senha_svg__g",
    width: 20,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "icon_senha_svg__b",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 17,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(8.734 15.643)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.367 17.541)",
    stroke: "#707070",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "icon_senha_svg__g",
    width: 1.266,
    height: 2.531,
    rx: 0.633
  }), /*#__PURE__*/React.createElement("rect", {
    className: "icon_senha_svg__b",
    x: 0.5,
    y: 0.5,
    width: 0.266,
    height: 1.531,
    rx: 0.133
  })))));
}
export default __webpack_public_path__ + "static/media/icon_senha.b7f73cb9.svg";
export { SvgIconSenha as ReactComponent };